import * as faker from 'faker';

export function slugify(input: string): string {
    return input === null ? '' : faker.helpers.slugify(input.toLocaleLowerCase()) + '.html';
}
